function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "data-error",
  transform: "translate(-6.75 -3.375)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_11501",
  "data-name": "Path 11501",
  d: "M15.774,10.137a2.262,2.262,0,1,1-2.262-2.262A2.262,2.262,0,0,1,15.774,10.137Z",
  transform: "translate(4.547 4.547)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11502",
  "data-name": "Path 11502",
  d: "M15.774,19.137a2.262,2.262,0,1,1-2.262-2.262A2.262,2.262,0,0,1,15.774,19.137Z",
  transform: "translate(4.547 13.642)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11503",
  "data-name": "Path 11503",
  d: "M15.774,28.137a2.262,2.262,0,1,1-2.262-2.262A2.262,2.262,0,0,1,15.774,28.137Z",
  transform: "translate(4.547 22.737)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11504",
  "data-name": "Path 11504",
  d: "M47.463,3.375H11.274A4.524,4.524,0,0,0,6.75,7.9V57.66a4.524,4.524,0,0,0,4.524,4.524H29.369V57.66H11.274V44.088H51.987V7.9A4.524,4.524,0,0,0,47.463,3.375Zm0,36.19H11.274V25.994h36.19Zm0-18.095H11.274V7.9h36.19Z",
  transform: "translate(0 0)",
  fill: "#ac1ede"
}));

var SvgDataError = function SvgDataError(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45.237,
    height: 58.808,
    viewBox: "0 0 45.237 58.808",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDataError, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/data-error.e73f7173.svg";
export { ForwardRef as ReactComponent };